export const tableColumns = [
    {
        title: '用户名',
        dataIndex: 'userName',
        key: 'userName',
        width: 160,
        fixed: 'left'
    },
    {
        title: '系统类型',
        key: 'sysType',
        // dataIndex: 'sysType',
        // 所属系统： MGR-运营平台, MCH-商户中心
        scopedSlots: {
            customRender: 'sysTypeSlot'
        },
        width: 160
    },
    {
        title: '业务类型',
        key: 'bizType',
        // dataIndex: 'bizType',
        // PAY_IN, PAY_OUT
        scopedSlots: {
            customRender: 'bizTypeSlot'
        },
        width: 100
    },
    {
        title: '下载次数',
        dataIndex: 'downloadCount',
        key: 'downloadCount',
        width: 100
    },
    {
        title: '商户号',
        dataIndex: 'mchNo',
        key: 'mchNo',
        width: 100,
        customRender: (text) => {
            return text || '--'
        }
    },
    {
        title: '文件名',
        key: 'fileName',
        dataIndex: 'fileName',
        width: 160,
        customRender: (text) => {
            return text || '--'
        }
    },
    {
        title: '状态',
        key: 'status',
        // dataIndex: 'fileUrl',
        width: 160,
        scopedSlots: {
            // 0-待处理, 1-处理成功, 2-处理失败
            customRender: 'fileUrlSlot'
        }
    },
    {
        title: '导出文件OSS下载链接',
        dataIndex: 'ossAddress',
        key: 'ossAddress',
        width: 260,
        customRender: (text) => {
            return text || '--'
        }
    },
    {
        title: '操作请求参数',
        dataIndex: 'optReqParam',
        key: 'optReqParam',
        width: 160,
        customRender: (text) => {
            if (!text) return '--'
            try {
                // 尝试格式化JSON
                const formatted = JSON.stringify(JSON.parse(text), null, 2)
                return formatted
            } catch (e) {
                // 如果不是JSON，直接返回原文本
                return text
            }
        }
    },
    {
        title: '失败原因',
        dataIndex: 'failedReason',
        key: 'failedReason',
        width: 160,
        customRender: (text) => {
            return text || '--'
        }
    },
    {
        title: '创建时间',
        // dataIndex: 'createdAt',
        key: 'createdAt',
        scopedSlots: {
            customRender: 'createdAtSlot'
        },
        width: 220
    }
    // {
    //     title: '更新时间',
    //     key: 'updatedAt',
    //     width: 220,
    //     scopedSlots: {
    //         customRender: 'updatedAtSlot'
    //     }
    // }
]
